import { render } from "./SmsCommunication.vue?vue&type=template&id=2bd2a2d2&scoped=true"
import script from "./SmsCommunication.vue?vue&type=script&lang=js"
export * from "./SmsCommunication.vue?vue&type=script&lang=js"

import "./SmsCommunication.vue?vue&type=style&index=0&id=2bd2a2d2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd2a2d2"]])

export default __exports__